// Dependencies
import { FC, MouseEventHandler, ReactElement } from "react";

// Styles
import { StyledMenuItem } from "./OptionMenu.styled";

interface OptionItemProps {
  children: ReactElement | string;
  onClick: MouseEventHandler;
}

const OptionItem: FC<OptionItemProps> = ({ children, onClick }) => {
  return <StyledMenuItem onClick={onClick}>{children}</StyledMenuItem>;
};

export default OptionItem;
